// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"c-PaymentLogosBar__wrapper","logo":"c-PaymentLogosBar__logo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/PaymentLogosBar/PaymentLogosBar.scss
// module id = 871
// module chunks = 0